import React, { useState } from "react";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";
const { cadToWon } = require("../../config");

// PriceTable component showing tiered prices
const PriceTable = ({ value, t }) => {
    // Get prices from the value.pricePerPerson array
    const getPriceForPeople = (numPeople) => {
        const priceEntry = value?.pricePerPerson?.find(
            (price) => price.type === `p${numPeople}`
        );
        return priceEntry?.amount || 0;
    };

    const p1 = getPriceForPeople(1);
    const p2 = getPriceForPeople(2);
    const p3 = getPriceForPeople(3);
    const p4 = getPriceForPeople(4);

    return (
        <table className={styles.priceTable}>
            <thead>
                <tr>
                    <th>{t("NumberOfPeople")}</th>
                    <th>{t("PricePerPerson")}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1 {t("Persons")}</td>
                    <td>C${p1}</td>
                </tr>
                <tr>
                    <td>2 {t("Persons")}</td>
                    <td>C${p2}</td>
                </tr>
                <tr>
                    <td>3 {t("Persons")}</td>
                    <td>C${p3}</td>
                </tr>
                <tr>
                    <td>4 {t("Persons")}</td>
                    <td>C${p4}</td>
                </tr>
            </tbody>
        </table>
    );
};

// TotalPriceCalculator component that uses the tiered prices
const TotalPriceCalculator = ({ value, t }) => {
    const [people, setPeople] = useState(1);
    const { i18n } = useTranslation(); // Add this to get the current language
    const langCode = i18n.language;

    const getPriceForPeople = (numPeople) => {
        if (
            value?.pricePerPerson?.length > 0 &&
            value.pricePerPerson.some((price) => price.amount > 0)
        ) {
            const priceEntry = value.pricePerPerson.find(
                (price) => price.type === `p${numPeople}`
            );
            return priceEntry?.amount || 0;
        }
        return value?.price || 0;
    };

    const pricePerPerson = getPriceForPeople(people);
    const totalPrice = pricePerPerson * people;
    const totalPriceInWonRaw = totalPrice * cadToWon;
    const totalPriceInWonRounded = Math.round(totalPriceInWonRaw);
    const totalPriceInWon = Math.round(totalPriceInWonRounded / 1000) * 1000;

    return (
        <div className={styles.totalPriceContainer}>
            <div className={styles.totalPriceCalculator}>
                <table className={styles.priceBreakdownTable}>
                    <tbody>
                        <tr className={styles.priceRow}>
                            <td>{t("NumberOfPeople")}</td>
                            <td>
                                <select
                                    id="peopleCount"
                                    value={people}
                                    onChange={(e) =>
                                        setPeople(parseInt(e.target.value))
                                    }
                                    className={styles.peopleDropdown}
                                >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </td>
                        </tr>
                        <tr className={`${styles.priceRow} ${styles.totalRow}`}>
                            <td>{t("TotalPrice")}</td>
                            <td>
                                C${totalPrice.toFixed(2)}
                                {langCode === "kr" || langCode === "ko" ? (
                                    <>
                                        &nbsp;(
                                        {totalPriceInWon.toLocaleString()}&nbsp;
                                        {t("WON")})
                                    </>
                                ) : null}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// Export both components as named exports
export { PriceTable, TotalPriceCalculator };
